export class UnauthorizedException {
  message: string | undefined;
  constructor(message?: string) {
    this.message = message;
  }
}